import type { Attachment } from "./contracts";
import { authorizedFetch, newIdempotencyKey, request } from "./transport";

export async function listAttachments(
  boardId: string,
  ticketId: string,
): Promise<Attachment[]> {
  return (
    await request<Attachment[]>(
      "GET",
      `/api/v1/boards/${boardId}/tickets/${ticketId}/attachments`,
    )
  ).body;
}

export async function uploadAttachment(
  boardId: string,
  ticketId: string,
  file: File,
): Promise<Attachment> {
  const form = new FormData();
  form.append("file", file);
  const response = await authorizedFetch(
    `/api/v1/boards/${boardId}/tickets/${ticketId}/attachments`,
    { method: "POST", headers: { "Idempotency-Key": newIdempotencyKey() }, body: form },
  );
  if (!response.ok) throw new Error("Attachment upload failed");
  return (await response.json()) as Attachment;
}

export async function attachmentBlob(
  boardId: string,
  ticketId: string,
  attachmentId: string,
  preview = false,
): Promise<Blob> {
  const suffix = preview ? "/preview" : "";
  const response = await authorizedFetch(
    `/api/v1/boards/${boardId}/tickets/${ticketId}/attachments/${attachmentId}${suffix}`,
  );
  if (!response.ok) throw new Error("Attachment download failed");
  return response.blob();
}

export async function deleteAttachment(
  boardId: string,
  ticketId: string,
  attachment: Attachment,
): Promise<void> {
  await request<void>(
    "DELETE",
    `/api/v1/boards/${boardId}/tickets/${ticketId}/attachments/${attachment.id}`,
    undefined,
    { etag: attachment.version },
  );
}
